import { Accordion, AccordionDetails, Grid, AccordionSummary, AppBar, Button, Dialog, DialogActions, DialogContent, Icon, IconButton, Stack, TextField, Toolbar, Typography, Tooltip, Alert, AlertTitle } from "@mui/material";
import { useContext, useEffect } from "react";
import { useState } from "react";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import OAuthService from "src/app/auth/services/oAuthService";
import moment from "moment";
import Select from "react-select";
import customStyles from "app/shared-components/SelectCustomStyle";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import { handleSuccessMsg } from "./OkrPerformance";
import jwtDecode from "jwt-decode";
import { HideShowAddCommentPopup } from "./GroupRowInnerRenderer";

const AddComments = (props) => {
    const [open, setOpen] = useContext(HideShowAddCommentPopup);
    const [fullOKr, setFullOKr] = useState();
    const [checkDraft, setCheckDraft] = useState(true);
    const [currentUpdateNo, setCurrentUpdateNo] = useState();
    const [error, setError] = useState();
    const [successMsg, setSuccessMsg] = useContext(handleSuccessMsg)

    const okrUrl = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.okrs}`;
    const okrSuburl = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.performance}`;
    const token = (localStorage && localStorage.getItem('token')) && jwtDecode(localStorage.getItem('token'));

    const statusList = [
        { label: 'OK', value: 'OK' },
        { label: 'CRITICAL', value: 'CRITICAL' },
        { label: 'DELAY', value: 'DELAY' },
    ]

    useEffect(() => {
        if (props.open) {
            setOpen(props.open)
        }
    }, [props.open]);

    function diff_weeks(dt2, dt1) {
        var diff = (dt2.getTime() - dt1.getTime()) / 1000;
        diff /= (60 * 60 * 24 * 7);
        return Math.abs(Math.round(diff));

    }

    const addWeeksToDate = (dateObj, numberOfWeeks) => {
        dateObj.setDate(dateObj.getDate() + numberOfWeeks * 7);
        return dateObj;
    }

    const getOkr = async (id) => {
        const okr = await OAuthService.getEditData(okrUrl, id);
        if (okr?.data) {
            const getTotalWeeks = diff_weeks(new Date(okr?.data.startDate), new Date(okr?.data.endDate));
            const duration = okr?.data?.weekDuration || 3;
            let weekstartDate = moment(new Date(okr?.data.startDate)).format('YYYY-MM-DD')
            let weekendDate = moment(addWeeksToDate(new Date(okr?.data.startDate), duration)).format('YYYY-MM-DD')
            const chunks = []
            for (let i = 0; i <= getTotalWeeks; i += duration) {
                const startWeek = moment(weekstartDate).week();
                const endWeek = moment(weekendDate).week()
                const week = (startWeek + '-' + endWeek).toString();
                chunks.push({ startDate: weekstartDate, endDate: weekendDate, weeks: week })
                weekstartDate = moment(weekendDate).add(1, 'days').format('YYYY-MM-DD');
                weekendDate = moment(addWeeksToDate(new Date(weekstartDate), duration)).format('YYYY-MM-DD')
                if (addWeeksToDate(new Date(weekstartDate), duration) > new Date(okr?.data.endDate)) {
                    weekendDate = moment(new Date(okr?.data.endDate)).format('YYYY-MM-DD')
                }
            }
            const currentdate = new Date();
            let updateNumber = chunks.findIndex((val) => currentdate >= new Date(val.startDate) && currentdate <= new Date(val.endDate));
            let getCurrentUpdateNumber = updateNumber >= 0 ? updateNumber + 1 : 1;
            setCurrentUpdateNo(getCurrentUpdateNumber)
            const getCurrent = chunks.filter((val) => currentdate >= new Date(val.startDate) && currentdate <= new Date(val.endDate));
            let commentStartDate = null;
            let commentEndDate = null;
            let commentWeekNo = '';
            if (getCurrent.length > 0) {

                commentStartDate = getCurrent[0].startDate
                commentEndDate = getCurrent[0].endDate
                commentWeekNo = getCurrent[0].weeks
            } else {
                commentStartDate = moment(new Date(okr?.data.startDate)).format('YYYY-MM-DD')
                commentEndDate = moment(addWeeksToDate(new Date(okr?.data.startDate), duration)).format('YYYY-MM-DD')
                const startWeek = moment(commentStartDate).week();
                const endWeek = moment(commentEndDate).week()
                const week = (startWeek + '-' + endWeek).toString();
                commentWeekNo = week
            }

            if (okr?.data?.objective.length > 0) {
                okr?.data.objective.map((obj) => {
                    let objects = {
                        objectiveValue: obj.objectiveValue
                    }
                    if (obj?.keyResult.length > 0) {
                        obj?.keyResult.map((result) => {
                            objects = { ...objects, keyResultValue: result.keyResultValue }
                            if (result?.keyResultStatus.length > 0) {
                                const filter = result.keyResultStatus.filter((status) => getCurrentUpdateNumber === status.updateNo);

                                if (filter.length > 0) {
                                    result.keyResultStatus
                                } else {
                                    result.keyResultStatus.push({
                                        id: result.keyResultStatus.length.toString(),
                                        startDate: commentStartDate,
                                        endDate: commentEndDate,
                                        updateNo: getCurrentUpdateNumber,
                                        weekNo: commentWeekNo,
                                        status: '',
                                        comment: '',
                                        createdAt: moment(new Date()).format('YYYY-MM-DD'),
                                        createdBy: token.email,
                                    })
                                }
                            } else {
                                result.keyResultStatus[0] = {};
                                result.keyResultStatus[0].id = '0';
                                result.keyResultStatus[0].startDate = commentStartDate;
                                result.keyResultStatus[0].endDate = commentEndDate;
                                result.keyResultStatus[0].updateNo = getCurrentUpdateNumber;
                                result.keyResultStatus[0].weekNo = commentWeekNo;
                                result.keyResultStatus[0].status = '';
                                result.keyResultStatus[0].comment = '';
                                result.keyResultStatus[0].createdAt = moment(new Date()).format('YYYY-MM-DD');
                                result.keyResultStatus[0].createdBy = token.email;

                            }
                        })
                    }
                })
            }
        }
        setFullOKr(okr?.data)
    }

    useEffect(() => {
        if (props.id) {
            getOkr(props.id)
        }

    }, [props.id]);

    const handleCommentChange = (e, ok, rk, sk) => {
        let okr = { ...fullOKr };
        okr.objective[ok].keyResult[rk].keyResultStatus[sk].comment = e.target.value;
        setFullOKr(okr)
    }
    const handleStatusChange = (data, ok, rk, sk) => {
        let okr = { ...fullOKr };
        okr.objective[ok].keyResult[rk].keyResultStatus[sk].status = data.value;
        setFullOKr(okr)
    }

    useEffect(() => {
        console.log(currentUpdateNo);
        if (currentUpdateNo && fullOKr) {
            let isDraft = true
            console.log(fullOKr);
            fullOKr?.objective.map((obj) => {
                if (obj.keyResult.length > 0) {
                    obj.keyResult.map((result) => {
                        if (result.keyResultStatus.length > 0) {
                            result.keyResultStatus.map((status) => {
                                if (status?.updateNo === currentUpdateNo && status?.status && status?.comment) {
                                    isDraft = false;
                                } else {
                                    isDraft = true;
                                }
                            })
                        }
                    })
                }
            })
            setCheckDraft(isDraft);
        }
    }, [currentUpdateNo, fullOKr])

    console.log(checkDraft);

    const handleOKRSubmit = async () => {
        const object = { ...fullOKr, isDraft: false };

        delete object.createdAt;
        delete object.createdBy;
        delete object.updatedAt;
        delete object.updatedBy;
        delete object._links;
        delete object.approverEmail;
        const list = await OAuthService.putData(okrSuburl + '/updateOkr', object);
        setSuccessMsg("OKR updates added successfully.")
        setOpen(false)

    }
    const handleOKRSaveDraft = async () => {
        let object = { ...fullOKr, isDraft: true };
        const error = '';
        const objective = object.objective.map((obj) => {
            obj.keyResult.map((result) => {
                const emptyIndex = result.keyResultStatus.findIndex((st) => !st.status && !st.comment);
                const checkValidation = result.keyResultStatus.filter((st) => (st.status && !st.comment) || (!st.status && st.comment));
                if (checkValidation.length > 0) {
                    setError('Please fill both field status and comment');
                    error = 'Please fill both field status and comment';
                } else {
                    if (emptyIndex >= 0) {
                        result.keyResultStatus.splice(emptyIndex, 1);
                    }
                }
                return result
            })
            return obj
        })
        object = { ...object, objective: objective }
        delete object.createdAt;
        delete object.createdBy;
        delete object.updatedAt;
        delete object.updatedBy;
        delete object._links;
        delete object.approverEmail;
        if (!error) {
            const list = await OAuthService.putData(okrSuburl + '/updateOkr', object)
            setSuccessMsg("OKR updates submitted as draft successfully.")
            setOpen(false)
        }
    }

    return (
        <>
            <Dialog
                open={open}
                maxWidth="lg"
                fullWidth={true}
            >
                <AppBar position="static">
                    <Toolbar className="flex w-full justify-between">
                        <Typography variant="subtitle1" color="inherit">
                            Add OKR Update
                        </Typography>
                        <IconButton
                            aria-label="close"
                            onClick={() => setOpen(false)}
                            sx={{
                                color: (theme) => theme.palette.grey[500],
                            }}
                        >
                            <Icon>close</Icon>
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <DialogContent>
                    {error && <Alert severity="error" className="mb-16">
                        <AlertTitle>Error</AlertTitle>
                        {error}
                    </Alert>}
                    {(fullOKr && fullOKr?.objective) && fullOKr?.objective.map((obj, ok) => {
                        return (
                            <Accordion sx={{ backgroundColor: '#202020' }}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                >
                                    <Typography>{obj.objectiveValue}</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    {obj.keyResult.map((result, rk) => {
                                        return (
                                            <Accordion >
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                >
                                                    <Typography>{result.keyResultValue}</Typography>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    {
                                                        result.keyResultStatus.map((status, sk) => {

                                                            return (
                                                                <>
                                                                    {sk === (result.keyResultStatus.length - 1) && <div>
                                                                        <Grid container spacing={2} className="mt-0 ml-0">
                                                                            <Grid item xs={3}><label>Start date: </label></Grid>
                                                                            <Grid item>{status?.startDate}</Grid>
                                                                            <Grid item xs={3}><label>Update No.: </label></Grid>
                                                                            <Grid item>{status?.updateNo}</Grid>
                                                                        </Grid>
                                                                        <Grid container spacing={2} className="mt-0 ml-0">
                                                                            <Grid item xs={3}><label>End date: </label></Grid>
                                                                            <Grid item>{status?.endDate}</Grid>
                                                                            <Grid item xs={3}><label>Week No: </label></Grid>
                                                                            <Grid item>{status?.weekNo}</Grid>
                                                                        </Grid>
                                                                        <Grid container spacing={2} className="mt-0 ml-0">
                                                                            <Grid item xs={3}><label>Status: </label></Grid>
                                                                            <Grid item>
                                                                                <Select
                                                                                    options={statusList}
                                                                                    value={(statusList && status?.status) && statusList.filter((st) => st.value === status?.status)}
                                                                                    styles={customStyles()}
                                                                                    onChange={(data) => handleStatusChange(data, ok, rk, sk)}
                                                                                />
                                                                            </Grid>
                                                                        </Grid>
                                                                        <Grid container spacing={2} className="mt-0 ml-0">
                                                                            <Grid item xs={3}><label>Update:</label></Grid>
                                                                            <Grid item xs={5}>
                                                                                <Stack>
                                                                                    <TextField
                                                                                        value={status?.comment}
                                                                                        onChange={(e) => handleCommentChange(e, ok, rk, sk)}
                                                                                        rows={4}
                                                                                        multiline
                                                                                    /></Stack>
                                                                            </Grid>
                                                                        </Grid>
                                                                    </div>}
                                                                </>
                                                            )
                                                        })
                                                    }
                                                </AccordionDetails>
                                            </Accordion>
                                        )
                                    })}
                                </AccordionDetails>
                            </Accordion>
                        )
                    })}

                </DialogContent>
                <DialogActions
                    sx={{ background: "#373c42" }}
                >
                    {checkDraft ?
                        <Tooltip title="Save As Draft">
                            <Button
                                variant="contained"
                                color="warning"
                                onClick={handleOKRSaveDraft}
                            >
                                <FuseSvgIcon>heroicons-outline:save-as</FuseSvgIcon> Save As Draft
                            </Button>
                        </Tooltip>
                        :
                        <Tooltip title="Submit All updates">
                            <Button
                                variant="contained"
                                color="warning"
                                onClick={handleOKRSubmit}
                            >
                                <Icon>save</Icon> Submit Updates
                            </Button>
                        </Tooltip>
                    }
                </DialogActions>
            </Dialog>
        </>
    )

}
export default AddComments